// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".date-time-range-picker .date-time-range-picker-times .time-picker input{border:0;-webkit-box-shadow:0 1px 0 rgba(0,0,0,.1);box-shadow:0 1px 0 rgba(0,0,0,.1);font-size:1em;text-align:left}.src-Profile-Pages-AbsenceRequest-AbsenceRequestForm-Form__absenceTypeDropdown--mmrlH{margin-top:.7em}@media only screen and (max-width: 600px){.src-Profile-Pages-AbsenceRequest-AbsenceRequestForm-Form__formSplit--uB5Tc{display:grid;grid-template-columns:1fr;padding:1em;gap:1rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"absenceTypeDropdown": "src-Profile-Pages-AbsenceRequest-AbsenceRequestForm-Form__absenceTypeDropdown--mmrlH",
	"formSplit": "src-Profile-Pages-AbsenceRequest-AbsenceRequestForm-Form__formSplit--uB5Tc"
};
export default ___CSS_LOADER_EXPORT___;
